import { useEffect, useState } from 'react';

import { type Theme } from '~/v1/system/theme/theme.manager';

export const getFavicon = (theme: Theme): string => {
  const { primary, copy } = theme;

  const favicon =
    `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1924_101988)">
  <rect width="48" height="48" fill="${primary}"/>
  <path d="M-4.85355 38.6903C-5.25229 38.436 -5.55397 38.1005 -5.75597 37.6864C-5.95796 37.2723 -6.03666 36.8346 -5.9842 36.3786C-5.45953 32.1746 -4.4994 28.3454 -3.10904 24.8884C-1.71868 21.4314 0.101901 18.5457 2.35008 16.2314C4.59827 13.9171 7.21372 12.4049 10.1991 11.6946C12.1324 11.27 13.7641 11.3303 15.0968 11.8728C16.4294 12.4153 17.3397 13.3825 17.8329 14.7716C18.3261 16.1607 18.334 17.8905 17.8591 19.9584C17.7568 20.2808 17.665 20.6189 17.5784 20.9753C17.3581 22.0604 17.2689 22.9174 17.3109 23.5438C17.3528 24.1703 17.4893 24.6682 17.7175 25.0325C17.9457 25.3969 18.2815 25.638 18.7222 25.7559C19.4016 25.9604 20.0234 25.8739 20.5926 25.5017C21.1619 25.1295 21.6157 24.5057 21.9541 23.633C22.2925 22.7602 22.4709 21.6961 22.4893 20.4433C22.4709 17.9691 22.7726 15.9064 23.3917 14.2526C24.0108 12.6014 24.8844 11.3643 26.0124 10.5414C27.1404 9.72102 28.4836 9.27546 30.0444 9.20731C31.9778 9.1051 33.5308 9.49562 34.7008 10.3763C35.8708 11.2569 36.7864 12.4232 37.4501 13.8726C38.1112 15.322 38.8929 17.4606 39.7901 20.2913C40.4171 22.291 41.0021 24.0366 41.5451 25.5279C42.0881 27.0192 42.7702 28.6049 43.5939 30.2823C44.4176 31.9597 45.3882 33.5873 46.5084 35.1625C46.7445 35.4665 46.8993 35.8413 46.9675 36.2816C47.0357 36.7219 46.9963 37.1465 46.852 37.5528C46.7078 37.959 46.4822 38.2893 46.1779 38.5435C45.8211 38.8475 45.4197 39.031 44.9685 39.0913C44.5199 39.1515 44.0897 39.0991 43.6831 38.9392C43.2765 38.7767 42.9617 38.5356 42.7413 38.2159C41.3667 36.2502 40.1967 34.2661 39.2287 32.2663C38.2607 30.2666 37.4947 28.4502 36.9254 26.8122C36.3562 25.1767 35.758 23.2844 35.1311 21.13C34.5382 19.2481 34.0581 17.8381 33.6935 16.8971C33.3288 15.9562 32.8829 15.204 32.3582 14.6353C31.8336 14.0665 31.1777 13.8018 30.3986 13.8359C29.6352 13.8359 29.0082 14.1163 28.5151 14.6746C28.0219 15.2329 27.6625 16.0847 27.4342 17.23C27.206 18.3754 27.0827 19.8614 27.0644 21.6908C27.0644 23.4023 26.6866 24.9356 25.9311 26.2932C25.1756 27.6482 24.1577 28.6861 22.8775 29.4069C21.5974 30.1276 20.1939 30.4526 18.6671 30.3845C17.3109 30.3164 16.1356 29.9101 15.144 29.1631C14.1524 28.4188 13.4546 27.3573 13.0585 25.9866C12.6597 24.6132 12.6728 22.9961 13.0978 21.13C13.2001 20.7578 13.3103 20.2991 13.4284 19.7566C13.6146 18.5352 13.6225 17.6074 13.4546 16.9732C13.2841 16.3389 12.8984 15.9772 12.2977 15.8933C11.6943 15.8095 10.8523 15.9955 9.7662 16.4516C7.73051 17.2982 5.93616 18.7344 4.38316 20.7604C2.83015 22.7864 1.58932 25.2003 0.655421 28.0047C-0.27848 30.8117 -0.87135 33.7708 -1.12581 36.8897C-1.17566 37.5161 -1.43536 38.0376 -1.90231 38.4517C-2.36926 38.8659 -2.91491 39.0755 -3.54451 39.0755C-4.01933 39.0755 -4.45743 38.9497 -4.85617 38.6929L-4.85355 38.6903Z" fill="${copy}"/>
  </g>
  <defs>s
  <clipPath id="clip0_1924_101988">
  <rect width="48" height="48" fill="${copy}"/>
  </clipPath>
  </defs>
  </svg>`.replace(/\n/g, '');

  return favicon;
};

interface IUseFavicon {
  favicon?: string;
  imageData?: string;
}

export const useFavicon = (theme?: Theme): IUseFavicon => {
  const [favicon, setFavicon] = useState<string>();
  const [imageData, setImageData] = useState<string>();

  useEffect(() => {
    if (!theme) {
      return;
    }

    const favicon = btoa(getFavicon(theme));
    const url = `data:image/svg+xml;charset=utf-8;base64,${favicon}`;
    svgUrlToPng(url, imageData => {
      setImageData(imageData);
      if (document.getElementById('faviconPng')) {
        document.body.removeChild(document.getElementById('faviconPng') as Node);
      }
    });

    setFavicon(favicon);
  }, [theme]);

  return {
    favicon,
    imageData,
  };
};

const svgUrlToPng = (svgUrl: string, callback: (imageData: string) => void) => {
  const svgImage = document.createElement('img');
  svgImage.setAttribute('id', 'faviconPng');

  document.body.appendChild(svgImage);
  svgImage.onload = function () {
    const canvas = document.createElement('canvas');
    canvas.width = svgImage.clientWidth;
    canvas.height = svgImage.clientHeight;
    const canvasCtx = canvas.getContext('2d');
    canvasCtx?.drawImage(svgImage, 0, 0);
    const imgData = canvas.toDataURL('image/png');

    callback(imgData);
  };

  svgImage.src = svgUrl;
};
